export enum CalculationBenefitDetailType {
  All = 0,
  RetirementOption,
  Beneficiary,
  CalculationParameter,
  BenefitCalculation,
  PayeeInformation = 6,
  QDROInformation = 7
}
